import React from 'react';
import { CrudModulePage } from '../components/common/CrudModulePage';
import { tenantModules } from '../config/modules';
import { Navigate } from 'react-router-dom';

interface ModulePageProps {
  moduleKey: string;
}

export const ModulePage: React.FC<ModulePageProps> = ({ moduleKey }) => {
  const config = tenantModules.find((m) => m.key === moduleKey);
  if (!config) return <Navigate to="/dashboard" />;
  return <CrudModulePage config={config} />;
};
